import { Col, Row, Modal } from "antd";
import {
  exportMarketAnalysis,
  exportMarketAnalysisFiles,
} from "api/marketAnalysisApi";
import { toast } from "helpers/generalHelper";
import { useEffect, useState } from "react";
import {
  CancelButton,
  PrimaryButton,
  SecondaryButton,
} from "../CustomButtons/CustomButtons";
import PreLoadPagesSpin from "components/PreLoadPagesSpin";

export default function DateAndExport({ dark_Theme, start_date, end_date }) {
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [showExportsTab, setShowExportsTab] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportItems, setExportItems] = useState([]);

  useEffect(() => {
    if (showExportsTab) {
      setIsLoading(true);
      exportMarketAnalysisFiles({})
        .then((response) => {
          setExportItems(response.data.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log("Error while exporting the data>>", error);
        });
    }
  }, [showExportsTab]);

  const handleExportMarketAnalysis = () => {
    setIsExportLoading(true);
    let params = { start_date, end_date };
    exportMarketAnalysis(params)
      .then((response) => {
        toast(response.data.message, "success");

        setIsExportLoading(false);
      })
      .catch((error) => {
        setIsExportLoading(false);
        console.log("Error while exporting the data>>", error);
      });
  };

  const handleExportItem = (url) => {
    const fileUrl = url;
    const a = document.createElement("a");
    a.href = fileUrl;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <>
      <Col span={24}>
        <Row size={"middle"} className={`${dark_Theme && "date-picker-dark"}`}>
          <Col span={3}>
            <span style={{ whiteSpace: "nowrap" }}>Data to include:</span>
          </Col>
          <Col className="gap-2 d-flex">
            <SecondaryButton
              onClick={handleExportMarketAnalysis}
              loading={isExportLoading}
            >
              Export
            </SecondaryButton>
            <SecondaryButton
              disabled={isExportLoading}
              onClick={() => setShowExportsTab(true)}
              // loading={isExportLoading}
            >
              Show Exports Tab
            </SecondaryButton>
          </Col>
        </Row>
      </Col>
      <Modal
        width={"40%"}
        className={` ${dark_Theme && "ant-modal-dark"}`}
        title={"Exports Tab"}
        open={showExportsTab}
        onCancel={() => setShowExportsTab(false)}
        onOk={() => setShowExportsTab(false)}
        footer={[
          <CancelButton key="cancel" onClick={() => setShowExportsTab(false)}>
            Cancel
          </CancelButton>,
        ]}
      >
        {isLoading ? (
          <PreLoadPagesSpin
            className={"other-info--container--spin"}
            size={"large"}
            dark_Theme={dark_Theme}
          />
        ) : (
          <div className="d-flex flex-column gap-3">
            {exportItems.length > 0 ? (
              exportItems.map((item) => (
                <div key={item.id} className="d-flex justify-content-between">
                  <div>
                    {item.name}{" "}
                    <span className="text-muted">({item.created_at})</span>
                  </div>
                  <div>
                    <SecondaryButton onClick={() => handleExportItem(item.url)}>
                      Download
                    </SecondaryButton>
                  </div>
                </div>
              ))
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100px" }}
              >
                <span className="text-muted">No Exports Found</span>
              </div>
            )}
          </div>
        )}
      </Modal>
    </>
  );
}
